module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "brand4.6a307629.jpg" + "?" + Date.now();